export const COS_PATH = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/JBH/2025'
